import Modal from "react-bootstrap/Modal";

function ImportantNoticeModal({ showModal, setShowModal }) {
  return (
    <Modal size={"lg"} centered={true} show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title className={"annoucement-modal-title"}>Important Notice</Modal.Title>
      </Modal.Header>
        <Modal.Body>
            <h4>Important Notice: e-IPO Subscription Guidelines:</h4>
            <p>Please read the following guidelines carefully before subscribing to any Initial Public Offering (IPO)
                through our platform:
            </p>
            <ol>
                <li>All IPO applications must comply with the applicable laws and regulations of the capital market
                    authority.
                </li>
                <li>Applicants must ensure their information is accurate and up-to-date before submission.</li>
                <li>Subscriptions are only accepted during the official IPO period as announced by the issuer.</li>
                <li>Once submitted, applications cannot be modified or withdrawn.</li>
                <li>Each investor is responsible for ensuring they meet the eligibility criteria set by the issuer.</li>
                <li>Multiple or duplicate applications may be rejected at the discretion of the issuer or regulator.
                </li>
                <li>Allotments are not guaranteed and are subject to the final decision of the issuer and underwriter.
                </li>
            </ol>
            <p>By proceeding, you acknowledge that you have read and understood the terms and conditions governing e-IPO
                subscriptions.</p>
        </Modal.Body>
    </Modal>
  );
}

export default ImportantNoticeModal;
